import { render, staticRenderFns } from "./VacationAttendance.vue?vue&type=template&id=b31561ac&scoped=true"
import script from "./VacationAttendance.vue?vue&type=script&lang=js"
export * from "./VacationAttendance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31561ac",
  null
  
)

export default component.exports